<template>
    <div class="public-pop">
        <div class="pop-mask"></div>
        <div class="pop-con">
            <div class="pop-title">
                <span class="pop-title-text">信息发布</span>
                <span class="pop-title-close" @click="closePop"></span>
            </div>
            <div class="pop-content">
                <el-form
                    label-position="left"
                    :model="form"
                    label-width="100px"
                    ref="form"
                    :rules="rules"
                    :hide-required-asterisk="true"
                >
                    <el-form-item
                        label="发布类型"
                        prop="releaseType"
                    >
                        <el-radio-group v-model="form.releaseType">
                            <el-radio :label="1">需求发布</el-radio>
                            <el-radio :label="2">成果发布</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item
                        label="标题"
                        prop="title"
                    >
                        <el-input v-model="form.title" placeholder="请输入标题"></el-input>
                    </el-form-item>
                    <el-form-item
                        label="简介"
                        prop="briefIntroduction"
                    >
                        <el-input type="textarea" v-model="form.briefIntroduction" placeholder="请输入简介"></el-input>
                    </el-form-item>
                    <el-form-item
                        label="联系人姓名"
                        prop="contacts"
                    >
                        <el-input v-model="form.contacts" placeholder="请输入联系人姓名"></el-input>

                    </el-form-item>
                    <el-form-item
                        label="手机号"
                        prop="phone"
                    >
                        <el-input v-model.number="form.phone" placeholder="请输入手机号"></el-input>
                    </el-form-item>
                    <el-form-item
                        label="邮箱"
                        prop="email"
                    >
                        <el-input v-model="form.email" placeholder="请输入邮箱"></el-input>

                    </el-form-item>
                </el-form>
            </div>
            <div class="pop-btn">
                <div class="pop-btn-confirm" @click="confirm">提交</div>
            </div>
        </div>
    </div>
</template>
<script>
import {formApi} from "@/api";

export default {
    name: "PublicPop",
    data() {
        var checkMobile = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('请输入手机号'));
            }
            if (!Number.isInteger(value)) {
                callback(new Error('请输入数字值'));
            } else {
                //校验手机号
                var reg = /^1[3456789]\d{9}$/;
                if (!reg.test(value)) {
                    callback(new Error('请输入正确的手机号'));
                } else {
                    callback();
                }
            }
        };
        var checkEmail = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('请输入邮箱'));
            }
            //校验邮箱
            var reg = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
            if (!reg.test(value)) {
                callback(new Error('请输入正确的邮箱'));
            } else {
                callback();
            }
        };
        return {
            form:{
                releaseType:1,
                title:'',
                briefIntroduction:'',
                contacts:'',
                phone:'',
                email:'',
            },
            rules:{
                releaseType:[
                    { required: true, message: '请选择发布类型', trigger: 'blur' }
                ],
                title:[
                    { required: true, message: '请输入标题', trigger: 'blur' }
                ],
                briefIntroduction:[
                    { required: true, message: '请输入简介', trigger: 'blur' }
                ],
                contacts:[
                    { required: true, message: '请输入联系人姓名', trigger: 'blur' }
                ],
                phone:[
                    {  validator:checkMobile,  trigger: 'blur' }
                ],
                email:[
                    { validator:checkEmail, trigger: 'blur' }
                ],
            }
        }
    },
    mounted() {
    },
    methods:{
        closePop(){
            this.$emit('closePop')
        },
        confirm(){
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    console.log(this.form)
                    var par = {...this.form}
                    console.log(par)
                    formApi(par).then(res => {
                        if (res.code === 200){
                            this.$message.success('发布提交成功')
                            this.$emit('closePop')
                        } else {
                            this.$message.error('发布失败')
                        }
                    })
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        }
    }
}
</script>
<style scoped lang="scss">

</style>
